import { createStaticVNode, defineComponent, openBlock, createElementBlock } from 'vue';

const _hoisted_1 = {
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g id="p1-mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="m1-\u641C\u5C0B-\u8F38\u5165\u4E2D" transform="translate(-299.000000, -54.000000)"><g id="\u641C\u5C0B\u6846" transform="translate(100.222222, 54.000000)"><g id="icon_search_clear" transform="translate(198.777778, 0.000000)"><rect id="bg" x="0" y="0" width="32" height="32"></rect><path id="\u5F62\u72B6\u7ED3\u5408" d="M16,7 C20.9705627,7 25,11.0294373 25,16 C25,20.9705627 20.9705627,25 16,25 C11.0294373,25 7,20.9705627 7,16 C7,11.0294373 11.0294373,7 16,7 Z M13.5251263,12.4644661 C13.232233,12.1715729 12.7573593,12.1715729 12.4644661,12.4644661 C12.1715729,12.7573593 12.1715729,13.232233 12.4644661,13.5251263 L14.939,16 L12.4644661,18.4748737 C12.1981995,18.7411403 12.1739935,19.157804 12.3918479,19.4514155 L12.4644661,19.5355339 C12.7573593,19.8284271 13.232233,19.8284271 13.5251263,19.5355339 L16,17.061 L18.4748737,19.5355339 C18.7411403,19.8018005 19.157804,19.8260065 19.4514155,19.6081521 L19.5355339,19.5355339 C19.8284271,19.2426407 19.8284271,18.767767 19.5355339,18.4748737 L17.061,16 L19.5355339,13.5251263 C19.8018005,13.2588597 19.8260065,12.842196 19.6081521,12.5485845 L19.5355339,12.4644661 C19.2426407,12.1715729 18.767767,12.1715729 18.4748737,12.4644661 L16,14.939 Z" fill-opacity="0.4" fill="#818D95"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
const __default__ = defineComponent({
  name: "TvbClearIcon"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  setup(__props) {
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Clear.vue2.mjs.map
